module.exports = __webpack_public_path__ + "static/media/navbar_logo.75f2fda9.png";